import { MutationTree } from 'vuex';
import { JobInput, JobState } from './state';

export const mutations: MutationTree<JobState> = {
  setJobInput(state, newJobInput: JobInput) {
    state.jobInput = { ...state.jobInput, ...newJobInput };
  },
};

export default mutations;
